
export default {
  submitText: '提交',
  submitBtn: false,
  emptyBtn: false,
  labelWidth: 120,
  column: [],
  group: [
    {
      column: [
        {
          label: "任务名称",
          prop: "name",
          disabled:true,
        },
        {
          label: "填报组织",
          prop: "deptName",
          disabled:true,
        },
        {
          label: "填报人",
          prop: "realName",
          disabled:true,
        },
        {
          label: "任务状态",
          prop: "processStatus",
          type: 'select',
          dataType: 'number',
          search: true,
          dicUrl: 'api/blade-system/dict/dictionary?code=task_process_status',
          props: {label: 'dictValue', value: 'dictKey'},
          disabled:true,
        },
        {
          label: "提交时间",
          prop: "submitTime",
          disabled:true,
        },
        {
          label: "反馈建议",
          prop: "description",
          type: 'textarea',
          span: 24,
          row: 4,
          disabled:true,
        },
        {
          label: "答题总分值",
          prop: "sum",
          disabled:true,
        },
        {
          prop: 'test',
          label: '题目内容',
          formslot: true,
          labelslot: true,
          span: 24,
          row:true,
        },
      ]
    },
  ],
};
